import {getAllProjectsURL, oneProjectURL} from '../../../services/api';
import {
    LOADING_DETAILS,
    PATCH_PROJECT,
    FETCH_PROJECT,
    PATCH_PROJECT_FAIL,
    FETCH_PROJECT_FAIL,
    DELETE_PROJECT_FAIL, DELETE_PROJECT, POST_PROJECT, POST_PROJECT_FAIL, SET_FAIL_MESSAGE_PROJECT
} from "../actionsType";
import api from '../../../services/instanceapi'
import {checkErrorMessage} from "../../../utils/utils";

export const loadProject = (id) => async (dispatch) => {
    dispatch({
        type: LOADING_DETAILS
    });

    try {
        const project = await api.get(oneProjectURL(id));
        const data = project.data;
        dispatch({
            type: FETCH_PROJECT,
            payload: {
                id: data.id,
                name: data.name,
                referenceCode: data.referenceCode,
                comment: data.comment,
                links: data.links,
                isConfidential: data.confidential,
                pilot: data.pilot,
                coPilot: data.coPilot,
                stake: data.stake,
                axisName: data.axisName,
                success: data.success,
                difficulties: data.difficulties,
                advancement: data.advancement,
                deadline: data.deadline,
                creationDate: data.creationDate,
                weather: data.weather,
                contributions: data.contributions,
                objectives: data.okrs,
                members: data.members,
                actions: data.actions,
                swot: data.swots,
                estimatedInvestmentBudget: data.estimatedInvestmentBudget,
                estimatedExploitationBudget: data.estimatedExploitationBudget,
                tags: data.tags,
                realInvestmentBudget: data.realInvestmentBudget,
                realExploitationBudget:data.realExploitationBudget,
                estimatedTimeSpent: data.estimatedTimeSpent,
                realTimeSpent: data.realTimeSpent,
                threatCreated: data.threatCreated,
                threatNotCreated: data.threatNotCreated,
                startDate: data.startDate,
                endDate: data.endDate,
                lastUpdate: data.lastUpdate,
                actionAdvancementAVG: data.actionAdvancementAVG,
                isTimeSpentOptional: data.isTimeSpentOptional,
                isBudgetOptional: data.isBudgetOptional,
                axisSponsor : data.axisSponsor,
                status: project.status,
                message: project.statusText,
                nextReview: data.nextReview

            }
        });
        return Promise.resolve()

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: FETCH_PROJECT_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_PROJECT,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }

}
export const patchProject = (id, project) => async (dispatch) => {
    try {
        const updatedProject = await api.patch(oneProjectURL(id), project);
        const data = updatedProject.data;
        dispatch({
            type: PATCH_PROJECT,
            payload: {
                id: data.id,
                name: data.name,
                referenceCode: data.referenceCode,
                comment: data.comment,
                links: data.links,
                isConfidential: data.confidential,
                pilot: data.pilot,
                coPilot: data.coPilot,
                stake: data.stake,
                axisName: data.axisName,
                success: data.success,
                difficulties: data.difficulties,
                advancement: data.advancement,
                deadline: data.deadline,
                creationDate: data.creationDate,
                weather: data.weather,
                contributions: data.contributions,
                objectives: data.okrs,
                swots: data.swots,
                members: data.members,
                actions: data.actions,
                tags: data.tags,
                estimatedInvestmentBudget: data.estimatedInvestmentBudget,
                estimatedExploitationBudget: data.estimatedExploitationBudget,
                realInvestmentBudget: data.realInvestmentBudget,
                realExploitationBudget:data.realExploitationBudget,
                estimatedTimeSpent: data.estimatedTimeSpent,
                realTimeSpent: data.realTimeSpent,
                threatCreated: data.threatCreated,
                threatNotCreated: data.threatNotCreated,
                startDate: data.startDate,
                endDate: data.endDate,
                lastUpdate: data.lastUpdate,
                status: updatedProject.status,
                isTimeSpentOptional: data.isTimeSpentOptional,
                isBudgetOptional: data.isBudgetOptional,
                message: "Updated",
                nextReview: data.nextReview
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: PATCH_PROJECT_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_PROJECT,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(e)
    }
}
export const deleteOneProject = (id) => async (dispatch) => {
    try {
        const deletedProject = await api.delete(oneProjectURL(id));
        dispatch({
            type: DELETE_PROJECT,
            payload: {
                status: deletedProject.status,
                message: deletedProject.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_PROJECT_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_PROJECT,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}
export const postProject = (data) => async (dispatch) => {
    try {
        const project = await api.post(getAllProjectsURL(), data);
        dispatch({
            type: POST_PROJECT,
            payload: {
                status: project.status,
                message: project.statusText
            }
        })
        return Promise.resolve()

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_PROJECT_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_PROJECT,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}
